module.exports = __webpack_public_path__ + "static/media/vulcan.26c55286.svg";